export default {
    apiKey: "AIzaSyBlDnR9TTTgvHVRcF1bz5lEzwHrfO9kWs8",
    authDomain: "vnpt-gomeet-v3.firebaseapp.com",
    projectId: "vnpt-gomeet-v3",
    storageBucket: "vnpt-gomeet-v3.firebasestorage.app",
    messagingSenderId: "45330196385",
    appId: "1:45330196385:web:396643d4e3b6921022cde0",
    measurementId: "G-65F3GNZ044"
  };